import { css } from 'linaria'
import fontSizes from '../../../styles/fontSizes'
import theme, {
  BORDERS, COLORS, ROUNDED,
} from '../../../styles/theme'

const classes = {
  calendarWrapper: css`
    min-height: ${theme.spacing(13.5)}px;
    div[class*='messageWrapper'] {
      margin-top: ${theme.spacing(3.75)}px;
      max-width: 86%;
      ${theme.breakpoints.down('sm')} {
        max-width: 100%;
      }
    }
    div[class*='spinner'] {
      position: relative;
      width: ${theme.spacing(7.5)}px;
      height: ${theme.spacing(7.5)}px;
      display: block;
      margin: 0 auto;
      margin-top: ${theme.spacing(11.25)}px;
      div {
        width: ${theme.spacing(7.5)}px;
        height: ${theme.spacing(7.5)}px;
      }
    }
  `,
  matrixBorder:css`
   border-right: ${BORDERS.gray3};
    border-left: ${BORDERS.gray3};
    border-bottom: ${BORDERS.gray3};
    padding: ${theme.spacing(1)}px;

  border-radius: 0px 0px 20px 20px;
  `,
  monthToggleWrapper:css`
  display:flex;
  align-items: center;
  justify-content: space-between;
  ${theme.breakpoints.down('sm')}{
  padding: ${theme.spacing(1)}px ${theme.spacing(2)}px;
  }
  padding: ${theme.spacing(2)}px;
  border:${BORDERS.gray3}
  border-radius: 20px 20px 0px 0px;
  `,
  selectedTimeslot: css`
  border-bottom: 2px solid ${theme.palette.primary.main};
  .MuiTypography-root {
    color: ${theme.palette.primary.main} ;
    font-weight: ${theme.typography.fontWeightBold!} ;
  }
`,
avalable:css`
     border: 1px solid ${theme.palette.secondary.main} ;
    cursor: default;
    background-color: ${theme.palette.secondary.main} ;
    opacity: 8% !important;
`,
  timeSlot:css`
  padding: ${theme.spacing(2)}px ;
  border-radius: ${ROUNDED.medium}px ;
  border: ${BORDERS.gray3} ;
  `,
  arrowButton: css`
    &.MuiButtonBase-root {
      background: ${COLORS.white};
      border-radius: ${ROUNDED.full};
      border: ${BORDERS.gray3};
      height: ${theme.spacing(6)}px;
      position: absolute;
      top: 50%;
      width: ${theme.spacing(6)}px;
      .MuiSvgIcon-root {
        font-size: ${fontSizes.h4};
      }
    }
    &.left {
      left: 0;
      transform: translate(-50%, -50%);
    }
    &.right {
      right: 0;
      transform: translate(50%, -50%);
    }
    ${theme.breakpoints.down('sm')} {
      &.MuiButtonBase-root {
        display: none;
      }
    }
  `,
  selectedDay: css`
    border-radius: 100%;
    border: 1px solid ${theme.palette.secondary.main};

  `,
  weekDay: css`
  &.MuiIconButton-root {
    padding:0px;
  }
    &.MuiButtonBase-root {
      max-height: ${theme.spacing(6)}px;
      max-width: ${theme.spacing(6)}px;
      position: relative; 
      overflow: visible; 
    }
    &.MuiButtonBase-root.selectedDay::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 48px;
    height: 48px;
    border: 1px solid ${theme.palette.secondary.main};
    border-radius: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    box-sizing: border-box;
    background-color: #eef8ef;
    z-index: -1;
  }
  }
    }
    .MuiButton-label {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &.currentDate:after {
      content: '';
      background-color: ${COLORS.primary};
      border-radius: 50%;
      height: ${theme.spacing(0.5)}px;
      left: 50%;
      position: absolute;
      top: 35px;
      transform: translate(-50%, ${theme.spacing(0.5)}px);
      width: ${theme.spacing(0.5)}px;
    }
    ${theme.breakpoints.down('sm')} {
      &.MuiButton-root.MuiButton-text {
        border-radius: ${ROUNDED.small}px;
        min-width: 0px;
        padding-left: ${theme.spacing(0.5)}px;
        padding-right: ${theme.spacing(0.5)}px;
      }
    }
  `,
  dateRange: css`
    width: 100%;
    ${theme.breakpoints.down('sm')} {
      min-width: ${theme.spacing(26)}px;
    }
  `,
  monthlyDesctop: css`
  border-radius: 0px 0px 20px 20px;
  `,
  weekDayInMonth: css`
  width: 48px;
  text-align: center;
  padding: ${theme.breakpoints.down('sm') ? theme.spacing(1) : theme.spacing(2)}px;
  
 `,
}

export default classes
